import React, {useCallback, useEffect, useMemo, useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import CloseButton from 'react-bootstrap/CloseButton';
import {useLocation} from 'react-router-dom';
import {luxdropEmbedRedirectUrl} from '../../config';

const STORAGE_KEY = 'kazlic_luxdrop_ad_modal_dismissed_at';
const TWENTY_FOUR_H_MS = 24 * 60 * 60 * 1000;

function readDismissedAt() {
    if (typeof window === 'undefined') return null;
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw == null || raw === '') return null;
        const n = Number(raw);
        return Number.isFinite(n) ? n : null;
    } catch {
        return null;
    }
}

function writeDismissedAt(ts) {
    try {
        localStorage.setItem(STORAGE_KEY, String(ts));
    } catch {
        /* private mode / quota — ignore */
    }
}

function shouldShowModal() {
    const last = readDismissedAt();
    if (last == null) return true;
    return Date.now() - last >= TWENTY_FOUR_H_MS;
}

const LuxdropAdModal = () => {
    const location = useLocation();
    const [show, setShow] = useState(false);

    const embedSrc = useMemo(
        () =>
            `https://luxdrop.com/embed/demo?redirect=${encodeURIComponent(luxdropEmbedRedirectUrl)}`,
        []
    );

    const onAdminRoute = location.pathname.startsWith('/admin');

    useEffect(() => {
        if (onAdminRoute) {
            setShow(false);
            return;
        }
        if (shouldShowModal()) setShow(true);
    }, [onAdminRoute, location.pathname]);

    const handleDismiss = useCallback(() => {
        writeDismissedAt(Date.now());
        setShow(false);
    }, []);

    if (onAdminRoute) return null;

    return (
        <Modal
            show={show}
            onHide={handleDismiss}
            centered
            className="luxdrop-ad-modal-root"
            backdropClassName="luxdrop-ad-modal-backdrop"
            dialogClassName="luxdrop-ad-modal-dialog"
            contentClassName="luxdrop-ad-modal-content"
            aria-labelledby="luxdrop-ad-modal-title"
        >
            <div className="luxdrop-ad-modal-inner">
                <div className="luxdrop-ad-modal-top">
                    <span className="luxdrop-ad-modal-badge" aria-hidden>
                        <span className="luxdrop-ad-modal-badge-dot" />
                        AD · LUXDROP
                    </span>
                    <CloseButton
                        variant="white"
                        className="luxdrop-ad-modal-close"
                        aria-label="Close"
                        onClick={handleDismiss}
                    />
                </div>

                <h2 id="luxdrop-ad-modal-title" className="luxdrop-ad-modal-title">
                    Claim your <span className="luxdrop-ad-modal-highlight">free pack</span> on LuxDrop — right now
                </h2>
                <p className="luxdrop-ad-modal-sub">
                    Open the pack and win real products from the world's top brands. No purchase required.
                </p>

                <div className="luxdrop-ad-modal-frame-wrap">
                    <iframe
                        className="luxdrop-ad-modal-iframe"
                        src={embedSrc}
                        title="LuxDrop pack"
                        scrolling="no"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        allow="clipboard-write"
                        sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
                    />
                </div>
            </div>
        </Modal>
    );
};

export default LuxdropAdModal;
